import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { PAGES_PATH } from "./params";
import { useUserStore } from "../hooks/redux-hooks/user-store/user.store";

const RedirectCompleteProfile = () => {
  const { isProfileComplete } = useUserStore();

  if (isProfileComplete) {
    return <Navigate replace to={PAGES_PATH.DASHBOARD} />;
  }

  return <Outlet />;
};

export default RedirectCompleteProfile;
